import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { BaseAsyncService, ListParams } from '@core/state/base-service'
import { SuccessionFileDto, UpdateFolderTypeRequest } from '@shared/models/dto/api-dtos'
import { ApiResponseWithDataInPages } from '@shared/models/interfaces'

@Injectable({ providedIn: 'root' })
export class SuccessionFilesService extends BaseAsyncService {
  list(params: ListParams): Observable<ApiResponseWithDataInPages<SuccessionFileDto>> {
    const query = this.buildQuery(params)
    return this.get<ApiResponseWithDataInPages<SuccessionFileDto>>(`/succession-files${query}`)
  }
  successionFileDetails(id: string): Observable<SuccessionFileDto> {
    return this.get<SuccessionFileDto>(`/succession-files/${id}`)
  }

  updateFolderType(id: string, body: UpdateFolderTypeRequest): Observable<void> {
    return this.put<void>(`/succession-files/${id}/folder-type`, body)
  }

  updateNotes(id: string, notes: string): Observable<void> {
    return this.put<void>(`/succession-files/${id}/notes`, { notes: notes })
  }
}
